export const THOUGHT_ACTIVITY = {
  thinking: { title: 'Thinking', explanation: "I'm deciding how to approach this." },
  plan: { title: 'Planning next steps', explanation: "I'm laying out what to do next." },
  research: { title: 'Researching', explanation: "I'm gathering reliable information." },
  documents: { title: 'Reviewing material', explanation: "I'm reading what you provided." },
  document: { title: 'Preparing file', explanation: "I'm turning findings into the deliverable." },
  compose: { title: 'Writing answer', explanation: "I'm drafting the response." },
  integration: { title: 'Connected services', explanation: "I'll pause if approval is needed." },
  ready: { title: 'Response ready', explanation: '' },
}

const GENERIC_BODIES = new Set([
  'Preparing an activity update…',
  "I'm completing this part of your request.",
])

export function thoughtActivityCopy(kind) {
  return THOUGHT_ACTIVITY[kind] ?? THOUGHT_ACTIVITY.thinking
}

export function resolveThoughtActivityKind({ category, phaseId, title, label } = {}) {
  const key = String(category ?? phaseId ?? '').toLowerCase()
  if (THOUGHT_ACTIVITY[key]) return key
  const text = `${title ?? ''} ${label ?? ''}`.toLowerCase()
  if (/starting stream|thinking/.test(text)) return 'thinking'
  if (/writing|draft|answer/.test(text)) return 'compose'
  if (/plan|strategy|deliverable|next step/.test(text)) return 'plan'
  if (/research|search|gather/.test(text)) return 'research'
  if (/upload|provided material|document/.test(text)) return 'documents'
  if (/file|deliverable|preparing final|creating content/.test(text)) return 'document'
  if (/composio|connected|integration|approval/.test(text)) return 'integration'
  if (/response ready|document ready|tasks completed/.test(text)) return 'ready'
  if (key.startsWith('observed:')) return 'thinking'
  return 'thinking'
}

export function thoughtActivityBody(body, kind) {
  const text = String(body ?? '').trim()
  if (text && !GENERIC_BODIES.has(text)) return text
  return thoughtActivityCopy(kind).explanation
}
